import Utils from 'core-helpers/utils.js';
import PlansHelper from 'core-helpers/plans-helper.js';

const TieredPlansHelper = (function(root, doc, undefined) {

    // Elements
    const tieredPlans = Utils.getById('tiered-plans');
    const tieredPlansNav = Utils.getById('tiered-plans-nav');

    /**
     * @private
     */
    const getTranslation = (key) => {
        return root.BUSUU_TRANSLATIONS[key] || 'TRS NOT FOUND';
    };

    /**
     * Returns the plan duration from a nav item
     * @param {Element} element
     * @return {Number}
     */
    const getPlanDuration = (element) => {
        const months = element.getAttribute('data-month-plan');
        return Number(months);
    };

    /**
     * Returns the relevant cart URL
     * @return {String}
     */
    const getCartURL = () => {
        return tieredPlans.getAttribute('data-success');
    };

    /**
     * @return {Array}
     */
    const getNavigationItems = () => {
        return Utils.getElementsByClass('js-navglide-item', tieredPlansNav);
    };

    /**
     * Validate each plan within a tier,
     * getFormattedPlan() will shortcut and throw an error
     * if the plan is not well formatted.
     * @param {Array} tier
     * @return Boolean
     * @private
     */
    const validateTierData = (tier) => {
        return tier.every((plan) => Boolean(PlansHelper.getFormattedPlan(plan)));
    };

    /**
     * Ensure the plans data is correct where
     * each plan within each tier is being checked.
     * @param {Object} plansData
     * @return Boolean
     */
    const isPlansStructureCorrect = (plansData) => {
        const casualPlans = plansData.plans.premium_standard;
        const seriousPlans = plansData.plans.premium_plus;

        if (!casualPlans || !seriousPlans) {
            return false;
        }

        const allTiersValid = [casualPlans, seriousPlans].every(validateTierData);
        return Boolean(allTiersValid);

    };

    /**
     * @param {Array} properties
     * @param {Object} source
     * @param {Object} target
     * @private
     */
    const addNewProperties = (properties, source, target) => {
        properties.forEach((prop) => {
            target[prop] = source[prop];
        });
    };

    /**
     * Returns a ready-to-be-stored plan
     * from a given tiered plan.
     * @param {Object} tieredPlan
     * @return {Object}
     */
    const getFormattedPlanBeforeStorage = (tieredPlan) => {
        const cleanPlan = {};
        const _tieredPlan = Utils.deepClone(tieredPlan);
        const requiredProps = ['planID', 'monthlyPrice', 'totalPrice', 'months', 'hasDiscount', 'tierType', 'vendors', 'hasFreeTrial'];
        const optionalDiscountProps = ['discountPercent', 'monthlyTotalSavings', 'totalSavings', 'monthlyPriceAfterDiscount', 'totalPriceAfterDiscount'];
        const optionalFreeTrialProps = ['freeTrialStrategy', 'freeTrialDays', 'monthlyPriceFreeTrial', 'totalPriceFreeTrial'];

        addNewProperties(requiredProps, _tieredPlan, cleanPlan);

        if (_tieredPlan.hasDiscount) {
            addNewProperties(optionalDiscountProps, _tieredPlan, cleanPlan);
        }

        if (_tieredPlan.hasFreeTrial) {
            addNewProperties(optionalFreeTrialProps, _tieredPlan, cleanPlan);
        }

        return cleanPlan;
    };

    return {
        getTranslation,
        getPlanDuration,
        getCartURL,
        getNavigationItems,
        isPlansStructureCorrect,
        getFormattedPlanBeforeStorage
    };

})(window, document);

export default TieredPlansHelper;
